import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { isLocalDevAuthBypass } from '@/config/runtimeEnv'
import { withTimeout } from '@/utils/navigationRecovery'

const AUTH_GUARD_TIMEOUT_MS = 8_000

export async function authGuard(
    to: RouteLocationNormalized,
): Promise<boolean | RouteLocationRaw> {
    if (isLocalDevAuthBypass()) {
        if (to.path === '/login') return { name: 'overview' }
        return true
    }

    const authStore = useAuthStore()

    if (!authStore.accessResolved) {
        await withTimeout(authStore.loadUser(), AUTH_GUARD_TIMEOUT_MS)
    }

    if (to.path === '/login') {
        if (authStore.isAuthenticated) return { name: 'overview' }
        return true
    }

    const requiresAuth = to.meta.requiresAuth !== false

    if (!requiresAuth) return true

    if (!authStore.isAuthenticated) {
        authStore.saveRedirectRoute(to)
        return { name: 'login' }
    }

    if (!authStore.canAccessStaff && to.meta.guestAllowed !== true) {
        return { name: 'overview' }
    }

    return true
}
